<template>
  <v-dialog v-model="show" max-width="600">
    <template v-slot:activator="{on}">
      <v-btn v-on="on" outlined tile light small>Flags</v-btn>
    </template>
    <v-card>
      <CardTitle title="Toggle Flags"></CardTitle>
      <v-card-text>
        <v-row justify="center" no-gutters>
          <v-col cols="8">
            <v-select v-model="addFlags" @change="onAddFlagChange" label="Add Flags" :items="sampleFlagTypes" item-text="name" return-object multiple></v-select>
            <v-select v-model="removeFlags" @change="onRemoveFlagChange" label="Remove Flags" :items="sampleFlagTypes" item-text="name" return-object multiple></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <CardActions @close="show = false" @submit="submit"></CardActions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ToggleFlags",
  data: () => ({
    show: false,
    removeFlags: [],
    addFlags: [],
  }),
  computed: {
    sampleFlagTypes(){
      return this.$store.$db().model('sampleFlagTypes').query().orderBy("display_index").all();
    }
  },
  methods: {
    onRemoveFlagChange(){
      for(let flag of this.removeFlags){
        let findFlag = this.addFlags.findIndex(f => f.uuid === flag.uuid);
        if(findFlag > -1){
          this.addFlags.splice(findFlag, 1)
        }
      }
    },
    onAddFlagChange(){
      for(let flag of this.addFlags){
        let findFlag = this.removeFlags.findIndex(f => f.uuid === flag.uuid);
        if(findFlag > -1){
          this.removeFlags.splice(findFlag, 1)
        }
      }
    },
    submit(){
      this.$emit('toggle_flags', {remove: this.removeFlags, add: this.addFlags})
      this.show = false;
    }
  }
}
</script>

<style scoped>

</style>